import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const IST_TIMEZONE = "Asia/Kolkata";

export function nowInIST(): Dayjs {
  return dayjs().tz(IST_TIMEZONE);
}

export function formatISTDate(
  value: string | number | Date | Dayjs,
  format: string = "D MMM YYYY",
): string {
  return toIST(value).format(format);
}

export function getISTDateString(date: string | number | Date | Dayjs = dayjs()): string {
  return toIST(date).format("YYYY-MM-DD");
}

function toIST(value: string | number | Date | Dayjs): Dayjs {
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      return dayjs.tz(trimmed, "YYYY-MM-DD", IST_TIMEZONE);
    }
    return dayjs(trimmed).tz(IST_TIMEZONE);
  }

  return dayjs(value).tz(IST_TIMEZONE);
}

/**
 * Get the Monday (start of week) for a given date
 */
export function getWeekStartDate(date: Date): Date {
  const d = new Date(date);
  const day = d.getDay(); // 0 = Sunday, 1 = Monday, etc.
  const diff = day === 0 ? -6 : 1 - day; // if Sunday, go back 6 days; otherwise go back to Monday
  d.setDate(d.getDate() + diff);
  d.setHours(0, 0, 0, 0);
  return d;
}

/**
 * Add weeks to a date
 */
export function addWeeks(date: Date, weeks: number): Date {
  const d = new Date(date);
  d.setDate(d.getDate() + weeks * 7);
  return d;
}

/**
 * Format a Date to YYYY-MM-DD in local timezone (avoids UTC conversion issues)
 */
export function formatDateToYYYYMMDD(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
